var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllSearchMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 380,
    height: 112.256,
    viewBox: "0 0 380 112.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ill_search_members",
    transform: "translate(190 56.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ill_search_members-2",
    "data-name": "ill_search_members",
    transform: "translate(-190 -56.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134707",
    "data-name": "Path 134707",
    d: "M87.177,14.827C51.726,3.057,16.5-5.179,8.564,15.387-6.286,54.011,26.879,39.8,8.319,74.426c-22.841,42.555,74.017,45.122,116.444,32.78,45.39-13.205,67.368,1.913,123.455,4.946,54.559,2.94,48.9-24.019,86.406-7.268,24.7,11.024,38.613,1.843,39.954-10.872s-11.315-18.245-8.166-35.265c3.371-18.28,32.488-34.121,9.332-46.8s-66.96-14.967-96.986,6.206S226.1-5.436,180.1,2.31C134.8,9.939,115.8,24.334,87.177,14.827Z",
    transform: "translate(-4.614 -1.398)",
    fill: "#bad3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134708",
    "data-name": "Path 134708",
    d: "M33.926,75.513a5.833,5.833,0,1,1-5.833,5.833,5.833,5.833,0,0,1,5.833-5.833m0-2.333a8.166,8.166,0,1,0,8.166,8.166,8.166,8.166,0,0,0-8.166-8.166Z",
    transform: "translate(-1.092 10.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134709",
    "data-name": "Path 134709",
    d: "M316.861,52.493a7.886,7.886,0,1,1-7.886,7.886,7.886,7.886,0,0,1,7.886-7.886m0-2.333a10.219,10.219,0,1,0,10.207,10.219A10.219,10.219,0,0,0,316.861,50.16Z",
    transform: "translate(45.685 6.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134710",
    "data-name": "Path 134710",
    d: "M228.676,71.513a5.833,5.833,0,1,1-5.833,5.833,5.833,5.833,0,0,1,5.833-5.833m0-2.333a8.166,8.166,0,1,0,8.166,8.166,8.166,8.166,0,0,0-8.166-8.166Z",
    transform: "translate(31.342 9.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134711",
    "data-name": "Path 134711",
    d: "M292.834,7.233a2.928,2.928,0,1,1-2.075.862,2.94,2.94,0,0,1,2.075-.862m0-2.333a5.273,5.273,0,1,0,5.261,5.273A5.273,5.273,0,0,0,292.834,4.9Z",
    transform: "translate(42.507 -0.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134712",
    "data-name": "Path 134712",
    d: "M119.173,75.263a3.857,3.857,0,1,1-.012,0m0-2.333a6.159,6.159,0,1,0,6.148,6.148,6.159,6.159,0,0,0-6.148-6.148Z",
    transform: "translate(13.435 10.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134713",
    "data-name": "Path 134713",
    d: "M20.356,9.753a3.815,3.815,0,1,1-3.815,3.815,3.815,3.815,0,0,1,3.815-3.815m0-2.333a6.148,6.148,0,1,0,4.355,1.8,6.148,6.148,0,0,0-4.355-1.8Z",
    transform: "translate(-3.014 -0.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134714",
    "data-name": "Path 134714",
    d: "M106.059,23.253a3.826,3.826,0,1,1-3.815,3.815,3.826,3.826,0,0,1,3.815-3.815m0-2.333a6.159,6.159,0,1,0,6.159,6.148,6.159,6.159,0,0,0-6.159-6.148Z",
    transform: "translate(11.255 1.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134715",
    "data-name": "Path 134715",
    d: "M221.011,43.783a3.815,3.815,0,1,1-2.7,1.121,3.826,3.826,0,0,1,2.7-1.121m0-2.333a6.159,6.159,0,1,0,6.148,6.159A6.159,6.159,0,0,0,221.011,41.45Z",
    transform: "translate(30.398 5.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134716",
    "data-name": "Path 134716",
    d: "M68.2,49.333a4.923,4.923,0,1,1-4.853,4.853A4.923,4.923,0,0,1,68.2,49.333M68.2,47a7.256,7.256,0,1,0,7.256,7.244A7.256,7.256,0,0,0,68.2,47Z",
    transform: "translate(4.767 6.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134717",
    "data-name": "Path 134717",
    d: "M279.668,79.333a4.9,4.9,0,1,1-3.484,1.431,4.923,4.923,0,0,1,3.484-1.431m0-2.333a7.256,7.256,0,1,0,7.244,7.244A7.256,7.256,0,0,0,279.668,77Z",
    transform: "translate(39.984 11.192)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11517",
    "data-name": "Ellipse 11517",
    cx: 5.868,
    cy: 5.868,
    r: 5.868,
    transform: "translate(26.966 86.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11518",
    "data-name": "Ellipse 11518",
    cx: 7.874,
    cy: 7.874,
    r: 7.874,
    transform: "translate(354.671 59.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11519",
    "data-name": "Ellipse 11519",
    cx: 5.868,
    cy: 5.868,
    r: 5.868,
    transform: "translate(254.15 81.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11520",
    "data-name": "Ellipse 11520",
    cx: 2.928,
    cy: 2.928,
    r: 2.928,
    transform: "translate(332.413 6.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11521",
    "data-name": "Ellipse 11521",
    cx: 3.815,
    cy: 3.815,
    r: 3.815,
    transform: "translate(128.793 85.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11522",
    "data-name": "Ellipse 11522",
    cx: 3.815,
    cy: 3.815,
    r: 3.815,
    transform: "translate(13.527 9.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11523",
    "data-name": "Ellipse 11523",
    cx: 3.815,
    cy: 3.815,
    r: 3.815,
    transform: "translate(113.5 25.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11524",
    "data-name": "Ellipse 11524",
    cx: 3.815,
    cy: 3.815,
    r: 3.815,
    transform: "translate(247.594 49.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11525",
    "data-name": "Ellipse 11525",
    cx: 4.923,
    cy: 4.923,
    r: 4.923,
    transform: "translate(68.04 55.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11526",
    "data-name": "Ellipse 11526",
    cx: 4.923,
    cy: 4.923,
    r: 4.923,
    transform: "translate(314.729 90.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11527",
    "data-name": "Ellipse 11527",
    cx: 18.665,
    cy: 18.665,
    r: 18.665,
    transform: "translate(43.111 4.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134718",
    "data-name": "Path 134718",
    d: "M58.566,4.9A18.665,18.665,0,0,1,53.69,41.658,18.665,18.665,0,1,0,58.566,4.9Z",
    transform: "translate(3.559 -0.815)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134719",
    "data-name": "Path 134719",
    d: "M64.947,29.99a12.9,12.9,0,0,1-8.341,2.625,1.167,1.167,0,1,1,0-2.333,10.429,10.429,0,0,0,10.7-8.166,1.167,1.167,0,0,1,2.263.537A12.832,12.832,0,0,1,64.947,29.99Z",
    transform: "translate(3.851 1.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134720",
    "data-name": "Path 134720",
    d: "M49.217,9.073a18.665,18.665,0,1,1-3.5,26.166,18.665,18.665,0,0,1,3.5-26.166M47.805,7.218a21,21,0,1,0,29.432,3.9,21,21,0,0,0-29.432-3.9Z",
    transform: "translate(1.208 -1.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134721",
    "data-name": "Path 134721",
    d: "M53.6,22.983a1.75,1.75,0,0,1-2.45-.327l-1.365-1.785a1.75,1.75,0,1,1,2.776-2.123l1.365,1.773a1.75,1.75,0,0,1-.327,2.461Z",
    transform: "translate(2.84 1.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134722",
    "data-name": "Path 134722",
    d: "M60.7,17.525a1.761,1.761,0,0,1-2.45-.327l-1.377-1.8a1.752,1.752,0,1,1,2.788-2.123l1.353,1.773a1.761,1.761,0,0,1-.315,2.473Z",
    transform: "translate(4.029 0.465)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11528",
    "data-name": "Ellipse 11528",
    cx: 18.665,
    cy: 18.665,
    r: 18.665,
    transform: "translate(286.825 40.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134723",
    "data-name": "Path 134723",
    d: "M287.163,48.07a18.665,18.665,0,0,1-36.653,5.588,18.665,18.665,0,1,0,36.653-5.588Z",
    transform: "translate(36.338 6.374)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134724",
    "data-name": "Path 134724",
    d: "M261.325,61.475a12.832,12.832,0,0,1-4.829-7.268,1.163,1.163,0,0,1,2.251-.583,10.5,10.5,0,0,0,10.86,7.991,1.168,1.168,0,1,1,.117,2.333A12.949,12.949,0,0,1,261.325,61.475Z",
    transform: "translate(37.329 7.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134725",
    "data-name": "Path 134725",
    d: "M280.578,40.213a18.665,18.665,0,1,1-26.1,3.99,18.665,18.665,0,0,1,26.1-3.99m1.388-1.878a15.02,15.02,0,1,1-.035,0Z",
    transform: "translate(36.005 4.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134726",
    "data-name": "Path 134726",
    d: "M263.992,48.948a1.738,1.738,0,0,1-.373-2.438l1.33-1.808a1.75,1.75,0,1,1,2.811,2.076l-1.307,1.8a1.75,1.75,0,0,1-2.461.373Z",
    transform: "translate(38.465 5.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134727",
    "data-name": "Path 134727",
    d: "M271.212,54.232a1.75,1.75,0,0,1-.373-2.45l1.33-1.8a1.75,1.75,0,0,1,2.811,2.065l-1.318,1.808a1.75,1.75,0,0,1-2.45.373Z",
    transform: "translate(39.667 6.593)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11529",
    "data-name": "Ellipse 11529",
    cx: 16.273,
    cy: 16.273,
    r: 16.273,
    transform: "translate(65.018 76.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134728",
    "data-name": "Path 134728",
    d: "M89.1,72.12A16.273,16.273,0,0,1,61.72,89.315,16.273,16.273,0,1,0,89.1,72.12Z",
    transform: "translate(4.896 10.38)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134729",
    "data-name": "Path 134729",
    d: "M73.325,90.067a11.315,11.315,0,0,1-6.4-4.153,1.019,1.019,0,0,1,1.61-1.248,9.087,9.087,0,0,0,11.455,2.613,1.02,1.02,0,1,1,.9,1.831,11.28,11.28,0,0,1-7.559.957Z",
    transform: "translate(5.727 12.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134730",
    "data-name": "Path 134730",
    d: "M70.992,79.2a1.517,1.517,0,0,1-1.167-1.82l.443-1.913a1.528,1.528,0,0,1,2.975.688l-.432,1.9a1.54,1.54,0,0,1-1.82,1.143Z",
    transform: "translate(6.24 10.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134731",
    "data-name": "Path 134731",
    d: "M78.612,80.962a1.517,1.517,0,0,1-1.167-1.82l.432-1.913a1.528,1.528,0,1,1,2.975.688l-.42,1.9a1.517,1.517,0,0,1-1.82,1.143Z",
    transform: "translate(7.509 11.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134732",
    "data-name": "Path 134732",
    d: "M76.821,100.761a17.2,17.2,0,0,1-3.885-.443,17.44,17.44,0,1,1,7.758-34.005h0a17.5,17.5,0,0,1-3.838,34.448ZM76.751,68.2a15.165,15.165,0,1,0,3.395.385h0a15.305,15.305,0,0,0-3.395-.385Z",
    transform: "translate(4.505 9.339)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11530",
    "data-name": "Ellipse 11530",
    cx: 12.225,
    cy: 12.225,
    r: 12.225,
    transform: "translate(6.108 46.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134733",
    "data-name": "Path 134733",
    d: "M30.466,44.15A12.214,12.214,0,0,1,11.44,59.233,12.214,12.214,0,1,0,30.466,44.15Z",
    transform: "translate(-3.477 5.722)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134734",
    "data-name": "Path 134734",
    d: "M20.352,58.553a8.481,8.481,0,0,1-5.121-2.578.763.763,0,1,1,1.1-1.062,6.836,6.836,0,0,0,8.761,1.015.764.764,0,0,1,.828,1.283,8.516,8.516,0,0,1-5.564,1.342Z",
    transform: "translate(-2.882 7.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134735",
    "data-name": "Path 134735",
    d: "M17.7,50.64a1.167,1.167,0,0,1-1.015-1.283l.175-1.458a1.174,1.174,0,0,1,2.333.268l-.175,1.458A1.167,1.167,0,0,1,17.7,50.64Z",
    transform: "translate(-2.606 6.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134736",
    "data-name": "Path 134736",
    d: "M23.514,51.3a1.167,1.167,0,0,1-1-1.26l.175-1.458a1.145,1.145,0,1,1,2.275.257L24.785,50.3A1.167,1.167,0,0,1,23.514,51.3Z",
    transform: "translate(-1.634 6.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134737",
    "data-name": "Path 134737",
    d: "M22.262,66.8a14.257,14.257,0,0,1-1.587-.07,13.31,13.31,0,1,1,1.575.093ZM22.2,42.3a11,11,0,1,0,1.295.07h0a12.039,12.039,0,0,0-1.295.012Z",
    transform: "translate(-3.894 5.064)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11531",
    "data-name": "Ellipse 11531",
    cx: 12.762,
    cy: 12.762,
    r: 12.762,
    transform: "translate(351.23 17.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134738",
    "data-name": "Path 134738",
    d: "M317.993,16.52a12.762,12.762,0,0,1-4.5,24.964,12.762,12.762,0,1,0,4.5-24.964Z",
    transform: "translate(46.827 1.12)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134739",
    "data-name": "Path 134739",
    d: "M321.438,33.841a8.912,8.912,0,0,1-5.833,1.517.8.8,0,0,1-.735-.863.817.817,0,0,1,.863-.735A7.139,7.139,0,0,0,323.3,28.51a.793.793,0,0,1,1.05-.5A.8.8,0,0,1,324.9,29a8.819,8.819,0,0,1-3.465,4.841Z",
    transform: "translate(47.057 3.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134740",
    "data-name": "Path 134740",
    d: "M313.859,28.723a1.167,1.167,0,0,1-1.7-.268l-.875-1.248a1.238,1.238,0,0,1,2.042-1.4l.875,1.248a1.167,1.167,0,0,1-.338,1.668Z",
    transform: "translate(46.423 2.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134741",
    "data-name": "Path 134741",
    d: "M318.882,25.231a1.167,1.167,0,0,1-1.657-.3l-.875-1.26a1.194,1.194,0,0,1,1.96-1.365l.875,1.26a1.167,1.167,0,0,1-.3,1.668Z",
    transform: "translate(47.268 1.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134742",
    "data-name": "Path 134742",
    d: "M318.653,43.357a13.929,13.929,0,0,1-7.967-25.372h0a13.929,13.929,0,1,1,7.967,25.372ZM312.05,19.9a11.665,11.665,0,1,0,8.679-1.878A11.665,11.665,0,0,0,312.05,19.9Z",
    transform: "translate(45.362 0.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11532",
    "data-name": "Ellipse 11532",
    cx: 12.89,
    cy: 12.89,
    r: 12.89,
    transform: "translate(227.949 8.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134743",
    "data-name": "Path 134743",
    d: "M219.09,10.29a12.832,12.832,0,0,1-15.76,20.193A12.89,12.89,0,1,0,219.09,10.29Z",
    transform: "translate(28.481 0.082)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134744",
    "data-name": "Path 134744",
    d: "M212.787,27.092a8.924,8.924,0,0,1-5.833-1.365.8.8,0,0,1-.257-1.108.828.828,0,0,1,1.167-.257,7.2,7.2,0,0,0,9.227-1.167.8.8,0,0,1,1.167,0,.782.782,0,0,1,0,1.167,8.936,8.936,0,0,1-5.471,2.73Z",
    transform: "translate(29.021 2.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134745",
    "data-name": "Path 134745",
    d: "M208.069,19.493a1.167,1.167,0,0,1-1.342-1.05l-.187-1.54a1.2,1.2,0,1,1,2.391-.292l.187,1.54a1.167,1.167,0,0,1-1.05,1.342Z",
    transform: "translate(29.014 0.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134746",
    "data-name": "Path 134746",
    d: "M214.221,18.721a1.167,1.167,0,0,1-1.353-1.05l-.187-1.482a1.176,1.176,0,1,1,2.333-.3l.257,1.47a1.167,1.167,0,0,1-1.05,1.365Z",
    transform: "translate(30.036 0.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134747",
    "data-name": "Path 134747",
    d: "M213.065,35.784a14.057,14.057,0,1,1,1.726-.1,14.431,14.431,0,0,1-1.726.1Zm0-25.792a12,12,0,0,0-1.435.093,11.665,11.665,0,1,0,1.435-.093Z",
    transform: "translate(27.763 -0.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134748",
    "data-name": "Path 134748",
    d: "M198.5,46.306a35.335,35.335,0,0,1-33.69,36.933,36.011,36.011,0,0,1-8.866-.712h0a35.428,35.428,0,0,1-8.761-3.115,34.413,34.413,0,0,1-10.861-8.632,34.635,34.635,0,0,1-7.886-16.752,30.954,30.954,0,0,1-.513-4.48,35.335,35.335,0,0,1,33.69-36.933,30.33,30.33,0,0,1,4.5.093,35.418,35.418,0,0,1,30.913,24.777h0a35.7,35.7,0,0,1,1.47,8.819Z",
    transform: "translate(15.916 0.463)",
    fill: "#e3f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134749",
    "data-name": "Path 134749",
    d: "M183.451,19.013,136.206,70.761a34.635,34.635,0,0,1-7.886-16.752L166,12.69a35,35,0,0,1,17.451,6.323Z",
    transform: "translate(15.988 0.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134750",
    "data-name": "Path 134750",
    d: "M194.23,35.146h0L153.191,80.174h0a35.428,35.428,0,0,1-8.761-3.115L190.322,26.7a35.51,35.51,0,0,1,3.908,8.446Z",
    transform: "translate(18.671 2.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134751",
    "data-name": "Path 134751",
    d: "M228.829,99.572l-27.075-24.7a4.782,4.782,0,0,0-.992-.7A44.084,44.084,0,0,0,164.482,5.07h-2.065a44.107,44.107,0,0,0,1.995,88.167h2.053a43.979,43.979,0,0,0,26.224-10.184,4.432,4.432,0,0,0,.735.887l27.11,24.731a4.666,4.666,0,0,0,3.231,1.225,4.747,4.747,0,0,0,3.5-1.539l1.9-2.077a4.76,4.76,0,0,0-.338-6.708ZM165.964,82.155h-1.54a32.663,32.663,0,0,1-6.743-.7h-.187a32.943,32.943,0,0,1-8.037-2.881A32.033,32.033,0,0,1,139.3,70.49a32.418,32.418,0,0,1-7.361-15.667,28,28,0,0,1-.467-4.141,33.048,33.048,0,0,1,31.5-34.495h1.6a19.246,19.246,0,0,1,2.613.117A33.058,33.058,0,0,1,195.991,39.3a.978.978,0,0,0,.058.2,33.468,33.468,0,0,1,1.412,8.166,33.048,33.048,0,0,1-31.5,34.495Z",
    transform: "translate(14.659 -0.787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134752",
    "data-name": "Path 134752",
    d: "M226.851,100.842,199.787,76.158a2.438,2.438,0,0,0-1.738-.63l-2.076.1a41.377,41.377,0,1,0-2.216,2.45l.093,2.041a2.5,2.5,0,0,0,.782,1.68l27.064,24.684a2.426,2.426,0,0,0,3.418-.152L227,104.26a2.426,2.426,0,0,0-.152-3.418Zm-61.185-16.8a36.011,36.011,0,0,1-8.866-.712h0a35.428,35.428,0,0,1-8.761-3.115,34.413,34.413,0,0,1-10.861-8.632,34.635,34.635,0,0,1-7.886-16.752,30.948,30.948,0,0,1-.513-4.48,35.335,35.335,0,0,1,33.69-36.933,30.33,30.33,0,0,1,4.5.093,35.418,35.418,0,0,1,30.913,24.777h0a35.7,35.7,0,0,1,1.517,8.772,35.335,35.335,0,0,1-33.748,36.979Z",
    transform: "translate(15.074 -0.342)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134753",
    "data-name": "Path 134753",
    d: "M190.3,70.586a35.23,35.23,0,0,1-24.637,11.665,36.011,36.011,0,0,1-8.866-.712h0a35.428,35.428,0,0,1-8.761-3.115,34.413,34.413,0,0,1-10.861-8.632,34.635,34.635,0,0,1-7.886-16.752,30.949,30.949,0,0,1-.513-4.48A35.276,35.276,0,0,1,138.11,22.9l-4.748-4.328a41.774,41.774,0,0,0,60.392,57.662l.093,2.041a2.5,2.5,0,0,0,.782,1.68l27.064,24.684a2.426,2.426,0,0,0,3.418-.152l1.085-1.167Z",
    transform: "translate(15.064 1.461)",
    fill: "#191919"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllSearchMembers);
export default __webpack_public_path__ + "static/media/ill_search_members.df008380d7c592b3843f447d393b65d0.svg";
export { ForwardRef as ReactComponent };